import { Component, OnInit, ChangeDetectionStrategy, Input, Inject } from '@angular/core';
import md from 'marked/lib/marked';
import { HttpClient } from '@angular/common/http';
import { VERSION_INFO } from './version-with-change-log.injections';
import { SchoolbelleService } from '@schoolbelle/api/schoolbelle';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-version-with-change-log',
  templateUrl: './version-with-change-log.component.html',
  styleUrls: ['./version-with-change-log.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class VersionWithChangeLogComponent implements OnInit {
  
  collapse:boolean = true;
  @Input() version:string
  @Input() production:boolean = true;
  constructor(
    private http:HttpClient,
    private sbe:SchoolbelleService,
    private i18n:I18n,
    @Inject(VERSION_INFO) version_info,
  ) {
    this.version = version_info.version;


  }
  ngOnInit() {
    this.getSchoolbelleVersionInfo();
  }
  getSchoolbelleVersionInfo () {
    this.sbe.checkVersion(this.version).subscribe(valid=>{
      if (this.production && !valid){
        alert(this.i18n('You are behind the minimum required version for our service to work correctly. Refresh the page please.'));    
      } 
    });
  }

  openCHANGELOG () {
    this.http.get('./CHANGELOG.md', {responseType:'text'}).subscribe(text=>{
      text = text.split('[Unlreased]')[1];
      text = text.replace(/Fixed/g, '수정');
      text = text.replace(/Added/g, '추가');
      text = text.replace(/Changed/g, '변경');
      text = text.replace(/Removed/g, '삭제');
      this.openPopup('CHANGELOG.md', md(text))     
    })
  }
  openPopup (title:string, html:string, dim:{w:number, h:number}={w:800, h:800}) {
    const {w, h} = dim;

    let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : (<any>screen).left;
    let dualScreenTop = window.screenTop != undefined ? window.screenTop : (<any>screen).top;

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;

    let mywindow = window.open('', '_blank', 'scrollbars=1, height=' + h + ',width=' + w + ', top=' + top + ', left=' + left);
    if (mywindow) {
      mywindow.document.write(`<html><head><title>${title}</title>`);
      mywindow.document.write('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">');
      mywindow.document.write('</head><body style="overflow:scroll;"><div class="container">');
      mywindow.document.write(html);
      mywindow.document.write('</div></body></html>');
      mywindow.document.close(); // necessary for IE >= 10
    }    
  }
}

